import { render, staticRenderFns } from "./ProllSrcTable.vue?vue&type=template&id=0aa94e86&scoped=true&"
import script from "./ProllSrcTable.vue?vue&type=script&lang=js&"
export * from "./ProllSrcTable.vue?vue&type=script&lang=js&"
import style0 from "./ProllSrcTable.vue?vue&type=style&index=0&id=0aa94e86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa94e86",
  null
  
)

export default component.exports